export const environment = {
  production: true,
  applicationName: "MyNjHelpsCustomer",
  appSettingsId: null,
  appVersion: 1,
  appLastBuild: null,
  baseUrl: "MyNjHelpsCustomer",
  defaultUrl: "WRKL",
  environment: "P", // D- Development, T-Testng ,S-Training , P-Production
  isProduction: true,
  checkAccess: true,
  allowedIdleTimeMins: 15, // Mins
  downloadLimit: 100,
  defaultRefmValue: {
    label: "-SELECT-",
    value: ""
  },
  logConfig: {
    logBaseUrl: "https://mynjhelps.gov/api/",
    logApiMethod: "Anonymous/ExternalLog"
  },
  apiConfig: {
    apiEndPoint: "https://mynjhelps.gov/api/",
    serviceRetryCount: 3,
    serviceRetryDelay: 500, // ms
    service2Cache: [],
    sessionTimeOut: 15, // Mins
    sessionWarningTime: 1
  },
  authConfig: {
    apiUrl: "https://ibmservices.taskmanagement.center/cain/",
    authUrl: "http://192.168.111.28:9080/server-proxy/",
    authMethod: "oauth/token",
    accessTokenContainer: "access_token",
    refreshTokenContainer: "refresh_token",
    sessionTimeOut: 14 // Mins
  },
  startTime: "6:00 AM",
  endTime: "6:00 PM",
  jsonEncode: true,
  siteKey: "6LeFAagpAAAAAKflwBVxvT03EW_cEckDOsUyDqpF",
  pktKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuSMZ7fZsjKo7The7KXw1VHhWd+xrkfrbuKhnO8Dyz2Nq/zHjfqmQIvp2FA70253PuS4es7Zij4B/AX1uRfsOaDoKRqngQKw/Gatw1zjhDH6MDa86erQLisglUVfxnTlY1zldfn449TZ1MyQhR/o55iXgFvADpG5Gu+udNm21P3Y78gfiokjXsFnS0fLjTYwJvdl6gDPBGTML9RZJlumhCoWrP9wvhFu1IMbR+OGsgPHnJk7R5hggNGeJrUvHH/m66i8QstYKJZ4MiFU65+uDirnJxkJU/KcUtZe2JKn1H/GubErMttOVwDSghXLnEJ6u5eS/zVHXGxwUPRcc6xrnrQIDAQAB"
};
